"use client";

import React from "react";
import { Search, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Link } from "@/components/common/Link";
export default function TheMissionHub() {
  return <section data-section-id="224501" id="the-mission-hub" className="bg-background text-foreground relative w-full min-h-[80vh] flex items-center justify-center overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-b from-background/20 via-background/60 to-background z-10" />
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/community_project_impact.png" alt="Community project impact" className="w-full h-full object-cover opacity-80 scale-110 animate-[pulse_8s_ease-in-out_infinite]" />
        {}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--background)_100%)] z-10" />
      </div>

      {}
      <div className="relative z-20 container mx-auto px-4 flex flex-col items-center text-center max-w-5xl">
        {}
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary/10 border border-primary/20 backdrop-blur-md mb-8">
          <Sparkles className="w-4 h-4 text-primary" />
          <span className="text-sm font-default font-semibold text-primary tracking-wide">
            Helping Hands Foundation
          </span>
        </div>

        {}
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-default font-bold tracking-tighter mb-8 leading-[1.1]">
          <span className="bg-gradient-to-br from-primary via-primary to-chart-2 bg-clip-text text-transparent">
            Small Hands,
          </span>
          <br />
          <span className="bg-gradient-to-br from-chart-2 to-primary bg-clip-text text-transparent">
            Big Impact
          </span>
        </h1>

        {}
        <div className="w-full max-w-2xl relative mb-12 group">
          <div className="absolute -inset-1 bg-gradient-to-r from-primary/20 to-chart-2/20 rounded-lg blur opacity-50 group-hover:opacity-75 transition duration-500"></div>
          <div className="relative flex items-center">
            <div className="absolute left-6 w-full pr-12 z-10 flex flex-col items-start">
               <div className="w-full h-6 bg-muted-foreground/20 rounded-md overflow-hidden mb-2">
                  <div className="h-full bg-gradient-to-r from-primary to-chart-2 w-[75%] transition-all duration-1000"></div>
               </div>
               <p className="text-sm font-default font-bold text-foreground">
                 Raised: <span className="text-primary">$750k</span> / Goal: $1M
               </p>
            </div>
            <div className="w-full h-24 sm:h-28 rounded-lg bg-card/80 border border-border backdrop-blur-xl shadow-xl" />
          </div>
        </div>

        {}
        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
          <Button asChild size="lg" className="w-full sm:w-auto rounded-md px-10 h-14 text-lg font-default font-bold bg-primary text-primary-foreground hover:bg-primary/90 shadow-xl transition-transform hover:scale-105">
            <Link to="/GetInvolvedPage">Join The Movement</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-md px-10 h-14 text-lg font-default font-bold border-primary/30 bg-background/50 hover:bg-muted text-primary backdrop-blur-md">
            <Link to="/FieldReportsPage">Watch Our Story</Link>
          </Button>
        </div>

        {}
        <div className="mt-16 pt-8 border-t border-border flex flex-wrap justify-center gap-8 text-sm text-muted-foreground font-default font-medium">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-md bg-chart-2"></div>
            100% Direct Impact
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-md bg-primary"></div>
            Transparent Reporting
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-md bg-chart-3"></div>
            Global Community Support
          </div>
        </div>
      </div>
    </section>;
}